<template>
  <div class="modal-overlay" v-if="isVisible" @click="closeModal($event)">
    <div class="modal-container" @click.stop>
      <!-- 窗口内容 -->
      <h2>律境问答</h2>
      <!-- 其他内容 -->
      <ai-view class="aibox" />
      <button @click="closeModal">关闭</button>
    </div>
  </div>
</template>  
    
  <script>
import AiView from "../views/sourceAiEnhance/index.vue";
export default {
  components: { AiView },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    closeModal(event) {
      // 阻止点击遮罩层时冒泡到父元素上
      if (event.target === event.currentTarget) {
        this.isVisible = false;
      }
    },
  },
};
</script> 
    
  <style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 深色遮罩 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* 确保在其他内容之上 */
  overflow: hidden; /* 防止滚动 */
}

.modal-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  /* 设置窗口大小，比如宽度为80%的视口宽度 */
  width: 80%;
  height: 80%;
  max-width: 1400px; /* 最大宽度限制 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: relative; /* 防止点击事件冒泡到遮罩层 */
  z-index: 10000; /* 确保在遮罩层之上 */
}
h2{
  margin-bottom: 20px;

}
.aibox{
  height: 86%;
}
button{
  margin-top: 20px;
}
</style>